interface StateConfig {
  label: string;
  className: string;
}

const STATE_CONFIG: Record<string, StateConfig> = {
  // Terminal states
  closed: { label: "Closed", className: "text-sage bg-sage-s" },
  cancelled: { label: "Cancelled", className: "text-rust bg-rust-s" },

  // Active / confirmed
  sent_invite: { label: "Invite Sent", className: "text-sage bg-sage-s" },
  signed_fee_agreement: {
    label: "Fee Agreement Signed",
    className: "text-spark bg-spark-s",
  },

  // Auth / payment
  pending_auth: { label: "Pending Auth", className: "text-tide-d bg-tide-s" },
  auth_completed: { label: "Auth Completed", className: "text-tide-d bg-tide-s" },

  // Background processing
  processing: { label: "Processing", className: "text-tide bg-tide-ss" },
  fee_ag_generated: {
    label: "Fee Agreement Generated",
    className: "text-tide bg-tide-ss",
  },

  // Outbound emails
  admin_email_sent: {
    label: "Admin Email Sent",
    className: "text-tide-d bg-tide-ss",
  },
  cust_email_sent: {
    label: "Customer Email Sent",
    className: "text-tide-d bg-tide-ss",
  },
  fee_email_sent: {
    label: "Fee Email Sent",
    className: "text-tide-d bg-tide-ss",
  },

  // Move / cancel transitions
  to_move: { label: "Queued to Move", className: "text-spark bg-spark-s" },
  moving: { label: "Moving", className: "text-spark bg-spark-s" },
  to_cancel: { label: "Queued to Cancel", className: "text-rust bg-rust-s/60" },
  cancelling: { label: "Cancelling", className: "text-rust bg-rust-s/60" },
};

interface BookingStateBadgeProps {
  state: string;
  className?: string;
}

export function BookingStateBadge({ state, className = "" }: BookingStateBadgeProps) {
  const config = STATE_CONFIG[state] ?? {
    label: state.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
    className: "text-ink-3 bg-canvas-2",
  };

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ${config.className} ${className}`}
    >
      {config.label}
    </span>
  );
}
